
<!-- padding-bottom: room to scroll the last field clear of the fixed button bar -->
<div style="padding-top: 1rem; padding-bottom: 96px;" class="row-not-wrap container flex-direction-xs-col col">
    <div class="col-md-3 col-lg-2 col-xs-12 register-left-side-menu">

        <mat-stepper [linear]="true" orientation="vertical" #stepper>
            <mat-step [stepControl]="this.hotelForm"> 
                <ng-template matStepperIcon="edit">
                    <mat-icon class="icon-display">check</mat-icon>
                 
                  </ng-template>
                  <ng-template    matStepLabel>B&B / Hotel / Motel
                    Owner</ng-template>
              </mat-step>
              <mat-step [stepControl]="this.entityRentalPropertyLicense"> 
                <ng-template matStepperIcon="edit">
                    <mat-icon class="icon-display">check</mat-icon>
                 
                  </ng-template>
                <ng-template matStepLabel>B&B / Hotel / Motel
                    License</ng-template>
            </mat-step>
            <mat-step [stepControl]="this.rentalProperty" > 
                <ng-template matStepperIcon="edit">
                    <mat-icon class="icon-display">check</mat-icon>
                 
                  </ng-template>
                <ng-template matStepLabel>Rental Property</ng-template>
            </mat-step>
            <mat-step [stepControl]="this.reporting" > 
                <ng-template matStepperIcon="edit">
                    <mat-icon class="icon-display">check</mat-icon>
                 
                  </ng-template>
                <ng-template matStepLabel>Rental Property
                    Reporting</ng-template>
            </mat-step>
            <mat-step > 
                <ng-template [stepControl]="this.rentalPropertyLicense" matStepperIcon="edit">
                    <mat-icon class="icon-display">check</mat-icon>
                 
                  </ng-template>
                <ng-template matStepLabel>Rental Property
                    Licences</ng-template>
            </mat-step>
            <mat-step [stepControl]="this.agreements"  > 
                <ng-template matStepperIcon="edit">
                    <mat-icon class="icon-display">check</mat-icon>
                 
                  </ng-template>
                <ng-template matStepLabel>Agreements</ng-template>
            </mat-step>
        </mat-stepper>
        </div>
        <div *ngIf="stepper.selectedIndex == 0" class="col-md-8 col-xs-12 register-main-content">
          <form [formGroup]="hotelForm">
            <div class="row gap-32 margin-bottom flex-direction-xs-col">
                <div class="col-md-4 col-xs-12">&nbsp;</div>
                  <div class="col-md-8 col-xs-12">
                    <div class="row gap-32 flex-direction-xs-col">
                      <mat-radio-group aria-label="Select owner’s address type">
                        <div class="row flex align-item-center gap-10">
                          <div class="col-md-12">
                            <mat-label> Select owner’s address type</mat-label>
                          </div>
                          <div class="col">
                            <mat-radio-button (change)="radioChangeAddress($event)" [checked]="true" color="primary"
                              value="1">Domestic</mat-radio-button>
                          </div>
                          <div class="col">
                            <mat-radio-button (change)="radioChangeAddress($event)" color="primary"
                              value="2">International</mat-radio-button>
                          </div>
                        </div>
                      </mat-radio-group>
                    </div>
                  </div>
            </div>
            <div class="row gap-32">
              <div class="col-md-4 col-xs-12">
                <div class="row">
                  <mat-form-field appearance="outline" requiered>
                    <mat-label style="font-size: 16px !important">Owner’s First name</mat-label>
                    <input matInput formControlName="firstName" placeholder="Owner’s First name" required />
                    <mat-error>Owner’s First name is required</mat-error>
                  </mat-form-field>
                </div>
                <div class="row">
                  <mat-form-field appearance="outline">
                    <mat-label style="font-size: 16px !important">Owner’s Last name</mat-label>
                    <input matInput formControlName="lastName" placeholder="Owner’s Last name" />
                    <mat-error>Owner’s Last name is required</mat-error>
                  </mat-form-field>
                </div>
                <div class="row">
                  <mat-form-field appearance="outline">
                    <mat-label style="font-size: 16px !important">Owner’s email address</mat-label>
                    <input matInput formControlName="email" placeholder="Owner’s Email" required />
                    <mat-error *ngIf="this.hotelForm.get('email')?.errors?.['email'] && (hotelForm.get('email')?.touched)">Owner’s
                      email address is invalid</mat-error>
            
                    <mat-error
                      *ngIf="this.hotelForm.get('email')?.errors?.['required'] && (hotelForm.get('email')?.touched)">Owner’s
                      email address is required</mat-error>
                  </mat-form-field>
                </div>
                <div class="row">
                  <mat-form-field appearance="outline">
                    <mat-label style="font-size: 16px !important">Owner’s Phone Number</mat-label>
                    <input matInput appPhoneFormat formControlName="phoneNumber" placeholder="Owner’s Phone Number" required />
                    <mat-error
                      *ngIf="this.hotelForm.get('phoneNumber')?.errors?.['pattern'] && (hotelForm.get('phoneNumber')?.touched)">Owner’s
                      Phone number is invalid</mat-error>
            
                    <mat-error
                      *ngIf="this.hotelForm.get('phoneNumber')?.errors?.['required'] && (hotelForm.get('phoneNumber')?.touched)">Owner’s
                      Phone number is required</mat-error>
            
                    <mat-error></mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-md-8 col-xs-12">
                <div *ngIf="addressType == '1'" class="row">
                  <mat-form-field class="full-width" appearance="outline">
                    <mat-label>Owner's Street Address</mat-label>
                    <input matInput class="form-outline form-control" placeholder="Owner's Street Address"
                      formControlName="ownerStreetAddress" [matAutocomplete]="auto" />
                    <mat-autocomplete #auto="matAutocomplete">
                      <mat-option *ngFor="let suggestion of suggestions" [value]="suggestion.description"
                        (onSelectionChange)="selectPlace(suggestion)">
                        {{ suggestion.description }}
                      </mat-option>
                    </mat-autocomplete>
                    <mat-error>Owners Street Address is required</mat-error>
                  </mat-form-field>
                </div>
                <div *ngIf="addressType == '2'" class="row">
                  <mat-form-field appearance="outline">
                    <mat-label>Addressee's Full Legal name</mat-label>
                    <input class="form-outline form-control" formControlName="addressName" matInput
                      placeholder="Addressee's Full Legal name" />
            
                    <mat-error>Addressee's Full Legal name is required</mat-error>
                  </mat-form-field>
                </div>
                <div *ngIf="addressType == '1'" class="row">
                  <mat-form-field appearance="outline">
                    <mat-label>Apt/Unit/Suite</mat-label>
                    <input matInput formControlName="aptUnitSuite" placeholder="Apt/Unit/Suite" />
                  </mat-form-field>
                </div>
                <div *ngIf="addressType == '2'" class="row">
                  <mat-form-field appearance="outline">
                    <mat-label>Street address or post office box number</mat-label>
                    <input formControlName="addressOrPoBox" class="form-outline form-control" matInput
                      placeholder="Street address or post office box number" />
            
                    <mat-error>Street address or post office box number is required</mat-error>
                  </mat-form-field>
                </div>
                <div *ngIf="addressType == '1'" class="row">
                  <div class="col">
                    <mat-form-field appearance="outline">
                      <mat-label>City</mat-label>
                      <input matInput formControlName="city" placeholder="City" />
                      <mat-error>City is required</mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col">
                    <mat-form-field appearance="outline">
                      <mat-label>State</mat-label>
            
                      <mat-select formControlName="state" placeholder="State">
                        @for (state of states; track state) {
                        <mat-option [value]="state.id.toString()">{{
                          state.name
                          }}</mat-option>
                        }
                      </mat-select>
            
                      <mat-error>State is required</mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col">
                    <mat-form-field appearance="outline">
                      <mat-label>Zip Code</mat-label>
                      <input matInput formControlName="zipCode" laceholder="Zip Code" />
                      <mat-error
                        *ngIf="this.hotelForm.get('zipCode')?.errors?.['pattern'] && (hotelForm.get('zipCode')?.touched)">Zip
                        Code is invalid</mat-error>
            
                      <mat-error
                        *ngIf="this.hotelForm.get('zipCode')?.errors?.['required'] && (hotelForm.get('zipCode')?.touched)">Zip
                        Code is required</mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div *ngIf="addressType == '2'" class="row">
                  <mat-form-field appearance="outline">
                    <mat-label>City, State, Province and Postal Code</mat-label>
                    <input class="form-outline form-control" formControlName="cityStateProvince" matInput
                      placeholder="City, State, Province and Postal Code" />
            
                    <mat-error>City, State, Province and Postal Code is required</mat-error>
                  </mat-form-field>
                </div>
                <div class="row" >
                  <mat-form-field appearance="outline" *ngIf="addressType == '2'">
                    <mat-label>Country</mat-label>
            
                    <mat-select formControlName="country" placeholder="Country">
                      @for (state of country; track state) {
                      <mat-option [value]="state.id">{{ state.name }}</mat-option>
                      }
                    </mat-select>
                    <mat-error>Country is required</mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <mat-form-field appearance="outline">
                  <mat-label>Notes</mat-label>
                  <textarea matInput formControlName="note" placeholder="Notes"></textarea>
                </mat-form-field>
              </div>
            </div>
          </form>
        </div>
        <div *ngIf="stepper.selectedIndex == 1" class="col-md-8 col-xs-12">
           <app-entitylicensestep [entityRentalPropertyLicense]="this.entityRentalPropertyLicense" #entitylicensestep ></app-entitylicensestep>
       
      </div>
      <div *ngIf="stepper.selectedIndex == 2" class="col-7">
        <app-rental-property  [rentalProperty]="rentalProperty" #rentalPropertyComponent [isMotelHotel]="true" [states]="this.states"></app-rental-property>
     
      </div>

      <div *ngIf="stepper.selectedIndex == 3" class="col-md-8 col-xs-12">
        <app-rental-property-reporting-form [rentalPropertyReporting]="this.reporting" #rentalPropertyReportingFormComponent [states]="this.states"></app-rental-property-reporting-form>

    </div>

    <div *ngIf="stepper.selectedIndex == 4" class="col-md-8 col-xs-12">
      <app-rental-property-license [providerOneLabel]="'Provide one of these fields'" [rentalPropertyLicense]="this.rentalPropertyLicense" #rentalPropertyLicenseComponent></app-rental-property-license>
 
  </div>
  <div *ngIf="stepper.selectedIndex == 5 && !stepCompleted" class="col-md-8 col-xs-12 pr-25">
  <app-agreements [agreements]="this.agreements"></app-agreements>
    </div>
    <div *ngIf="stepper.selectedIndex == 5 && stepCompleted" class="col-md-8 col-xs-12 pr-25">
      <app-step-complete  ></app-step-complete>
        
    </div>
</div>

<div  *ngIf="!stepCompleted" style="position: fixed; bottom: 0;width: 100%;background-color: white;">
  <div class="button-stepper-footer">
    <button (click)="openDialog()"  mat-stroked-button mat-button class="button-stepper-cancel">CANCEL<mat-icon>close</mat-icon></button>
    <button  (click)="goBack(stepper)"  *ngIf="stepper.selectedIndex >0" mat-stroked-button mat-button class="button-stepper-back">
      BACK
      <mat-icon>arrow_left_alt</mat-icon>
    </button>
    <button [disabled]="!hotelForm.valid"  [ngClass]="{'button-stepper-allow': hotelForm.valid ,'button-stepper': hotelForm.invalid  }" *ngIf="stepper.selectedIndex == 0" mat-stroked-button mat-button (click)="goForward(stepper)" class="button-stepper-allow">NEXT <mat-icon iconPositionEnd>arrow_right_alt</mat-icon></button>
    <button [disabled]="!entityRentalPropertyLicense.valid"  [ngClass]="{'button-stepper-allow': entityRentalPropertyLicense.valid ,'button-stepper': entityRentalPropertyLicense.invalid  }" *ngIf="stepper.selectedIndex == 1" mat-stroked-button mat-button (click)="goForward(stepper)" class="button-stepper-allow">NEXT <mat-icon iconPositionEnd>arrow_right_alt</mat-icon></button>
    <button [disabled]="!rentalProperty.valid"  [ngClass]="{'button-stepper-allow': rentalProperty.valid ,'button-stepper': rentalProperty.invalid  }" *ngIf="stepper.selectedIndex == 2" mat-stroked-button mat-button (click)="goForward(stepper)" class="button-stepper-allow">NEXT <mat-icon iconPositionEnd>arrow_right_alt</mat-icon></button>
    <button [disabled]="!reporting.valid"  [ngClass]="{'button-stepper-allow': reporting.valid ,'button-stepper': reporting.invalid  }" *ngIf="stepper.selectedIndex == 3" mat-stroked-button mat-button (click)="goForward(stepper)" class="button-stepper-allow">NEXT <mat-icon iconPositionEnd>arrow_right_alt</mat-icon></button>
    <button [disabled]="!rentalPropertyLicense.valid"  [ngClass]="{'button-stepper-allow': rentalPropertyLicense.valid ,'button-stepper': rentalPropertyLicense.invalid  }" *ngIf="stepper.selectedIndex == 4" mat-stroked-button mat-button (click)="goForward(stepper)" class="button-stepper-allow">NEXT <mat-icon iconPositionEnd>arrow_right_alt</mat-icon></button>
    <button [disabled]="!agreements.valid"  [ngClass]="{'button-stepper-allow': agreements.valid ,'button-stepper': agreements.invalid  }" *ngIf="stepper.selectedIndex == 5" mat-stroked-button mat-button (click)="save()" class="button-stepper-allow">SUBMIT <mat-icon iconPositionEnd>arrow_right_alt</mat-icon></button>
      
  </div>
  </div>